module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Pencil-81fc9ce3cc32ff1e65e59f6436821d8d001016d186c4c30908c2c2c1e1d92884.svg";